{
  "common": {
    "for": "para",
    "each": "cada",
    "eachLot": "Cada lote",
    "lot": "lot",
    "lots": "lotes",
    "selectAll": "Seleccionar todo",
    "unselectAll": "Deseleccionar todo"
  },
  "pageHeader": {
    "techSupport": "Soporte técnico",
    "auctionCompany": "Empresa de subastas",
    "welcome": "Bienvenido",
    "bidder": "Postor",
    "viewer": "Visor",
    "fullCatalog": "Ver catálogo completo"
  },
  "catalogAndMyPurchases": {
    "firstTab": "Catálogo",
    "secondTab": "Mis compras",
    "trackLots": "Permitir que el catálogo rastree lotes",
    "backToLots": "Volver a lotes",
    "passed": "Pasado",
    "pending": "Pendiente",
    "sold": "Vendido",
    "biddingNow": "HACER UNA OFERTA AHORA",
    "upNext": "UP NEXT",
    "confirmPurchases": "Todas las compras deben ser confirmadas por la empresa de subastas",
    "lot": "Lot",
    "backToMyPurchases": "Volver a mis compras"
  },
  "chat": {
    "loading": "Cargando chat ...",
    "header": "Chat en línea"
  },
  "mediaStreaming": {
    "failedConnection": "Conexión fallida!",
    "playBtn": "Reproducir medios en vivo",
    "connecting": "Conectando ...",
    "unmute": "Un-mute",
    "mute": "Mute",
    "tooltip": "Te has conectado correctamente<br/>a la plataforma de transmisión de medios"
  },
  "biddingArea": {
    "auctionPaused": "La subasta está en pausa",
    "waitingAuctionToStart": "Esperando a que comience el evento de subasta",
    "waitingBiddingToStart": "Esperando a que comience la licitación",
    "auctioneerConfirmed": "El subastador le dio",
    "soldPriceForEach": "Precio vendido por cada uno",
    "winningBid": "Oferta ganadora",
    "pendingSellerConfirmationForEach": "Precio de confirmación del vendedor pendiente para cada uno",
    "pendingBid": "Oferta pendiente",
    "auctioneerRefused": "El subastador no te dio mucho.",
    "sold": "Vendido!",
    "pendingSellerConfirmation": "Confirmación pendiente del vendedor",
    "bid": "Oferta",
    "roundCancelled": "La ronda se canceló",
    "noSale": "Pasado",
    "highestBidder": "Felicitaciones, usted es el mejor postor!",
    "youWon": "Felicitaciones! Ganaste",
    "waitingWinner": "Esperando que el ganador elija los lotes...",
    "totalPrice": "Precio total",
    "yourBidPending": "Su oferta está pendiente de confirmación del vendedor",
    "waitingWinnerChooseLots": "Pendiente de confirmación del vendedor. Esperando a que el ganador elija los lotes...",
    "youAreIn": "Ganando!",
    "viewOnly": "SOLO VER ",
    "registerLogin": "Registrarse/Acceso ",
    "clickToBid": "Haz clic para ofertar ",
    "swipeToBid": "Desliza para ofertar ",
    "waitingIncrement": "Esperando incremento",
    "totalBid": "Oferta total",
    "bidHistory": "Historial de ofertas",
    "floorFirst": "PISO PRIMERO",
    "waitAuctioneer": "Espere a que el Subastador confirme su elección",
    "makeSelections": "Por favor haga sus selecciones",
    "pricePendingConfirmation": "Precio pendiente de confirmación del vendedor para cada uno",
    "selectionSent": "Selección enviada",
    "sendSelection": "Enviar selección"
  },
  "currentRound": {
    "nowBidding": "Ahora haciendo una oferta",
    "scrollList": "lista de desplazamiento a continuación"
  },
  "webcastFinished": "El evento webcast ha cerrado. Gracias"
}
